module.exports = "/assets/data/4a4c5221cc79dff6e0c33a5c28e887eb-NR4.data.json";